import React, { PropsWithChildren } from 'react';

interface HBTTableCellProps extends PropsWithChildren {
  title?: string;
}

const HBTTableCell: React.FC<HBTTableCellProps> = ({ children, title }) => {
  return (
    <span
      style={{ whiteSpace: 'noWrap', overflow: 'hidden', textOverflow: 'ellipses' }}
      title={title}
    >
      {children}
    </span>
  );
};

export default HBTTableCell;
